import { Button } from '@/components/ui/button';
import { SimpleCard, type SimpleCardWidth } from '@/components/ui/simple-card';
import { ArrowLeft } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router';

export interface DashboardPageLayoutProps extends React.PropsWithChildren {
  title: React.ReactNode;
  width?: SimpleCardWidth;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  backLink?: string;
}

export function DashboardPageLayout({
  title,
  width = 'lg',
  description,
  actions,
  backLink,
  children,
}: DashboardPageLayoutProps): React.ReactElement {
  return (
    <main className="flex flex-1 flex-col">
      <SimpleCard width={width}>
        <div className="flex flex-col gap-3 p-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex w-full flex-col gap-1 md:flex-row md:gap-3">
            {backLink && (
              <Button variant="ghost" asChild>
                <Link to={backLink}>
                  <ArrowLeft />
                </Link>
              </Button>
            )}
            <div className="flex flex-1 flex-col gap-1">
              <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
              {description !== undefined && <p className="text-sm text-muted-foreground">{description}</p>}
            </div>
          </div>
          {actions !== undefined && (
            <div className="flex flex-col gap-2 sm:shrink-0 sm:flex-row *:w-full sm:*:w-auto">{actions}</div>
          )}
        </div>
        {children !== undefined && <div className="flex flex-col gap-6">{children}</div>}
      </SimpleCard>
    </main>
  );
}
